import React from 'react'
import Investors from './Investors'
import Means from './Means'
import Mission from './Mission'
import Together from './Together'
import Transform from "./Transform"
import Achieved from "./Achieved"
import Market from './Market'
import Footer from './Footer'

const About = () => {
  return (
    <div>
        <Mission />
        <Means />
        <Together />
        <Investors />
        <Transform />
        <Achieved />
        <Market />
        <Footer />
    </div>
  )
}

export default About